import { useQuery } from '@tanstack/react-query';

import { IPartnerV3 } from '../models/partnerV3';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const getPartner = async ({
  partnerId,
  makeRequest,
}: {
  partnerId: string;
  makeRequest: ImperativeRequestFn;
}): Promise<IPartnerV3> => {
  const { data, error } = await makeRequest({ path: `/partners/${partnerId}` });
  if (error) throw new Error(error?.message ?? String(error));

  return data.partner;
};

type QueryFnType = typeof getPartner;

export const useGetPartner = (
  partnerId: string,
  config?: QueryConfig<QueryFnType>
) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    enabled: !!partnerId,
    staleTime: 5 * 60 * 1000,
    ...config,
    queryKey: ['partner-v3', partnerId],
    queryFn: () => getPartner({ partnerId, makeRequest }),
  });
};
